import React from "react"
import Logo from "../../assets/logo/SPEDIDAM-LOGO-RVB_Positif.svg"

const ColoredLogo = () => {
    return(
        <img
            className="portal__item portal__logo"
            src={Logo}
            alt="Logo Spedidam"
            width="130"
        />
    )
}

export default ColoredLogo;